export function slugify(str: String) {
  let slug = String(str)
    // Normalize accented characters into their base characters and diacritics.
    .normalize('NFKD')
    // Remove diacritical marks.
    .replace(/[\u0300-\u036f]/g, '')
    // Remove all periods.
    .replace(/\./g, '')
    // Trim leading and trailing whitespace.
    .trim()
    // Convert to lowercase.
    .toLowerCase()
    // Replace sequences of characters that are not letters or digits with a hyphen.
    .replace(/[^a-z0-9]+/g, '-')
    // Collapse multiple hyphens into one.
    .replace(/-+/g, '-')
    // Remove any hyphen from the beginning or end.
    .replace(/^-|-$/g, '');
  
  // Return a fallback if the resulting slug is empty.
  return slug.length ? slug : 'n-a';
}